module.exports = __webpack_public_path__ + "img/content2.9d3bbf88.png";